module.exports = __webpack_public_path__ + "e1a0d9ffdb5686bbf6957f6326354233.svg";